<template>
  <div class="">
    <loading-spinner v-if="loading" />
    <template v-else>
      <div class="animated fadeIn m-3">
        <b-row>
          <b-col :cols="3">
            <b-card-group deck>
              <b-card footer-tag="footer">
                <b-row>
                  <b-col :cols="12" class="text-center">
                    <h1 style="font-size: 35px; color: #20A8D8">{{referralInfo.code}}</h1>
                  </b-col>
                </b-row>
                <template v-slot:footer>
                  <h6 class="mb-0 text-center" :id="referralInfo.code">REFERRAL CODE</h6>
                </template>
              </b-card>
            </b-card-group>
          </b-col>
          <b-col :cols="3">
            <b-card-group deck>
              <b-card footer-tag="footer">
                <b-row>
                  <b-col :cols="12" class="text-center">
                    <h1 style="font-size: 35px; color: #20A8D8">{{abbreviateNumber(referralInfo.count)}}</h1>
                  </b-col>
                </b-row>
                <template v-slot:footer>
                  <h6 class="mb-0 text-center" :id="referralInfo.count">CONVERSION (SIGNUPS)</h6>
                </template>
              </b-card>
            </b-card-group>
          </b-col>
          <b-col :cols="3">
            <b-card-group deck>
              <b-card footer-tag="footer">
                <b-row>
                  <b-col :cols="12" class="text-center">
                    <h1 style="font-size: 35px; color: #20A8D8">{{abbreviateNumber(referralInfo.conversion)}}</h1>
                  </b-col>
                </b-row>
                <template v-slot:footer>
                  <h6 class="mb-0 text-center" :id="referralInfo.conversion">CONVERSIONS (PAID)</h6>
                </template>
              </b-card>
            </b-card-group>
          </b-col>
          <b-col :cols="3">
            <b-card-group deck>
              <b-card footer-tag="footer">
                <b-row>
                  <b-col :cols="12" class="text-center">
                    <h1 style="font-size: 35px; color: #20A8D8">{{abbreviateNumber(referralInfo.points)}}</h1>
                  </b-col>
                </b-row>
                <template v-slot:footer>
                  <h6 class="mb-0 text-center" :id="referralInfo.points">POINTS</h6>
                </template>
              </b-card>
            </b-card-group>
          </b-col>
          <!-- <b-col :cols="3">
         
            <b-card-group deck>
              <b-card footer-tag="footer">
                <b-row>
                  <b-col :cols="8" class="text-center">
                    <h1 style="font-size: 35px; color: #20A8D8">{{abbreviateNumber(referralInfo.count)}}</h1>
                  </b-col>
                  <b-col :cols="4">
                    <span v-show="true" class="card-title" v-if="true" style="color: #5c5">
                      {{referralInfo.count}}% <i class="fa fa-arrow-up"></i>
                    </span>
                    <span v-show="true" class="card-title" v-else style="color: #c00">
                      {{referralInfo.count}}% <i class="fa fa-arrow-down"></i>
                    </span>
                    <p class="card-category">1 month</p>
                  </b-col>
                </b-row>
                <template v-slot:footer>
                  <h6 class="mb-0 text-center" :id="referralInfo.code">REFERRALS</h6>
                </template>
              </b-card>
              
         
            </b-card-group>
          </b-col>
          <b-col :cols="3">
            <b-card-group deck>
              <b-card footer-tag="footer">
                <b-row>
                  <b-col :cols="8" class="text-center">
                    <h1 style="font-size: 35px; color: #20A8D8">{{referralInfo.conversion}}</h1>
                  </b-col>
                  <b-col :cols="4">
                    <span v-show="true" class="card-title" v-if="true" style="color: #5c5">
                      {{referralInfo.conversion}}% <i class="fa fa-arrow-up"></i>
                    </span>
                    <span v-show="true" class="card-title" v-else style="color: #c00">
                       {{referralInfo.conversion}}% <i class="fa fa-arrow-down"></i>
                    </span>
                    <p class="card-category">1 month</p>
                  </b-col>
                </b-row>
                <template v-slot:footer>
                  <h6 class="mb-0 text-center">CONVERSIONS</h6>
                </template>
              </b-card>
            </b-card-group>
          </b-col> -->
        </b-row>
      </div>
      <b-card>
        <b-row>
          <b-col>
            <div class="mb-5">
              <h5 class="m-0">Refer Superfluid Platform and get rewarded</h5>
              <div>Grab your chance now!!</div>
              
              <hr/>
            </div>
          </b-col>
        </b-row>
        <b-row>
              <!-- <b-col cols :md=6 class="mb-3">
              <b-row>
                <b-col cols :md=3>
                  <label for="referral-code">
                    <h6>Referral Code:</h6>
                  </label>
                </b-col>
                <b-col cols :md=6>
                  <b-form-input 
                    id="referral-code" 
                    size="md" 
                    v-model="refCode"
                    disabled=""
                    style="color:#aaa"
                    :placeholder="refCode">
                  </b-form-input>
                </b-col>
                <b-col cols :md=3>
                  <b-button
                    size="md" 
                    variant="primary"  
                    type="button"
                    v-clipboard:copy="refCode"
                    v-clipboard:success="onCodeCopy"
                    v-clipboard:error="onError">
                    <i class="fa fa-copy"></i> Copy
                  </b-button>
                </b-col>
              </b-row>
            </b-col> -->
        
            <!-- <b-col cols :md=6></b-col> -->
                <b-col cols :md=6 >
              <b-row>
                <b-col cols :md=3>
                  <label for="referral-link">
                    <h6 >Referral Link:</h6>
                  </label>
                </b-col>
                <b-col cols :md=9>
                  
                  <b-form-input 
                    id="referral-link" 
                    size="md" 
                    v-model="refURL"
                    disabled="" 
                    style="color:#aaa"
                    :placeholder="refURL">
                  </b-form-input>
                </b-col>
           
          
              </b-row>
            </b-col>
            <b-col cols :md=6>
              <b-row>
                <!-- <b-col cols :md=2>
                  <label>
                    <h6>Share:</h6>
                  </label>
                </b-col> -->
                <b-col cols :md=2>
                  <b-button
                    size="md" 
                    variant="primary"  
                    type="button"
                    v-clipboard:copy="refURL"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError">
                    <i class="fa fa-copy"></i> Copy
                  </b-button>
                </b-col>
                <b-col cols :md=7>
                  <a :href="`https://www.facebook.com/sharer/sharer.php?u=` + refURL" target="_blank">
                    <i class="fa fa-facebook-official" style="font-size: 2.3rem"></i>
                  </a>&nbsp;&nbsp;&nbsp;
                  <a :href="`http://twitter.com/share?text=` + refURL" target="_blank">
                    <i class="fa fa-twitter" style="font-size: 2.3rem"></i>
                  </a>&nbsp;&nbsp;&nbsp;
                  <a :href="`whatsapp://send?text=` + refURL" data-action="share/whatsapp/share" target="_blank">
                    <i class="fa fa-whatsapp" style="font-size: 2.3rem"></i>
                  </a>
                </b-col>
              </b-row>

            </b-col>

    
            <!-- <b-col cols :md=6></b-col>
            <b-col cols :md=6 class="mb-3">
              <b-row>
                <b-col cols :md=5>
                  <label>
                    <h6>Share referral link:</h6>
                  </label>
                </b-col>
                <b-col cols :md=7>
                  <a :href="`https://www.facebook.com/sharer/sharer.php?u=` + refURL" target="_blank">
                    <i class="fa fa-facebook-official" style="font-size: 1.7rem"></i>
                  </a>&nbsp;&nbsp;&nbsp;
                  <a :href="`http://twitter.com/share?text=` + refURL" target="_blank">
                    <i class="fa fa-twitter" style="font-size: 1.7rem"></i>
                  </a>&nbsp;&nbsp;&nbsp;
                  <a :href="`whatsapp://send?text=` + refURL" data-action="share/whatsapp/share" target="_blank">
                    <i class="fa fa-whatsapp" style="font-size: 1.7rem"></i>
                  </a>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols :md=6></b-col> -->
          </b-row>
        <!-- <step
          v-if="step === 1"
          position="1"
          title="Create or Select a Project"
          description="Create a new project or select an existing project">
          
        </step> -->
      </b-card>
    </template>

    <file-project-modal
      :key="`file-project-${modalKey}`"
      :shown="isProjectModalOpen"
      @success="step = 2"
      @close="isProjectModalOpen = false"/>
  </div>

</template>

<script>
  import axios from "axios";
  import AlignMiddle from '../Sources/AlignMiddle';
  import SourceHeader from '../Sources/SourceHeader';
  import FileProject from '../Sources/FileProject';
  import FileProjectModal from '../Sources/FileProjectModal';
  import {hasAllRequiredEntities} from '../../utils';
  import Step from '../Sources/Step';
  import StepProgressSlider from '../Sources/StepProgressSlider';
  import Plans from '../Plans/Plans';
  import LoadingSpinner from "../LoadingSpinner";
  import CardDetail from '../CardDetail';
  import VueSweetalert2 from 'vue-sweetalert2';
  import swal from 'sweetalert2';

  window.Swal = swal;
  
  export default {
    name: 'ReferralProgram',
    components: {
      AlignMiddle,
      CardDetail,
      Step,
      StepProgressSlider,
      SourceHeader,
      FileProject,
      FileProjectModal,
      LoadingSpinner,
      Plans
    },

    data() {
      return {
        tab: 0,
        step: 1,
        totalSteps: 3,
        createProject: false,
        rawFile: null,
        project: this.$store.state.files.activeProject,
        verified: this.$store.state.general.user.verified,
        projectFieldMap: {},
        projectFiles: {},
        meta: null,
        mapMeta: null,
        mapFile: {},
        mapProject: null,
        refCode: '',
        refURL: '',
        isReady: false,
        isProjectModalOpen: false,
        modalKey: 1,
        loading: true,
        fileOperation: 'new_file',
        fileOperationOptions: [
          {text: 'Upload File', value: 'new_file'},
          {text: 'Select Existing File', value: 'existing_file'}
        ]
      };
    },
    mounted() {
      this.loading = false;
      this.refCode = this.referralInfo.code;
      this.refURL = this.referralInfo.info_url;
    },
    watch: {
      isMappingModalOpen() {
        console.log("Key: ", this.modalKey);
        this.renewModalKey();
      },
      rawFile: function(val) {
        console.log('Raw file: ', val);
        if (!!val) {
          this.file = val;
        }
      },
    },

    methods: {
      renewModalKey() {
        this.modalKey = this.modalKey + 1;
      },

      launchModal() {
        this.isMappingModalOpen = true;
        this.activeMeta = true;
      },

      nextStep() {
        this.step++;
        if (this.step === 2) {
          this.project = this.$store.state.files.activeProject;
        }
      },

      previousStep() {
        this.step--;
      },

      completeProject() {
        this.project = this.$store.state.files.activeProject;
        console.log("P: ", this.project);
        this.nextStep();
      },

      toggleProjectLabel(value, event) {
        this.createProject = value['save'];
      },

      mapColumnsForFile() {
        this.isMappingModalOpen = true;
      },

      uploadFile(meta) {
        console.log("Project File Meta: ", meta);
        this.mapMeta = meta;
        this.mapProject = this.project;
        this.isFileChangeModalOpen = true;
        // this.isMappingModalOpen = true;
      },

      uploadedFileFail(value, event) {
        this.mapMeta = value['meta'];
        this.mapProject = this.project;
        this.isFileChangeModalOpen = false;
        var count = value['rowCount'] - value['recordsLeft'];
        Swal.fire({
          title: "<span style='color: #fff; font-size: 1rem'>Sorry. Your file could not be uploaded because it contains <strong style='color: #fc0; font-size: 1.5rem'>" + count + "</strong> more records than what you have left on your current plan!</span>",
          text: "<span style='color: #fff'></span>",
          icon: 'warning',
          html: true,
          // showDenyButton: true,
          // color: "#fff",
          background: "#3a4149",
          showCancelButton: true,
          confirmButtonColor: '#0d4275',
          cancelButtonColor: '#750d0d',
          confirmButtonText: `Upgrade Plan`,
          denyButtonText: `Cancel`,
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.$router.push(`/plans`);
          } else if (result.isDenied) {
            // Swal.fire('Changes are not saved', '', 'info')
            this.$bvToast.toast('Sorry. Your file could not be uploaded because it contains ' + count + ' more records than what you have left on your current plan!', {
              title: 'Upload Failed',
              autoHideDelay: 5000000,
              variant: 'danger',
              solid: true
            });
          }
        });
      },
      
      uploadedFileSuccess(value, event) {
        this.mapMeta = value['meta'];
        this.mapProject = this.project;
        this.fileDetails.forEach(f => {
          if (f['_id'] === value['fileID']) {
            this.mapFile = f;
          }
        });
        this.isFileChangeModalOpen = false;
        this.isMappingModalOpen = true;
      },

      selectProjectFile(value, event) {
        this.projectFiles[value['meta']['type']] = value['fileID'];
        this.mapMeta = value['meta'];
        this.mapProject = this.project;
        this.fileDetails.forEach(f => {
          if (f['_id'] === value['fileID']) {
            this.mapFile = f;
          }
        });
        this.isMappingModalOpen = true;
      },

      abbreviateNumber(number) {
        var SI_SYMBOL = ["", "k", "M", "B", "T", "P", "E"];
        var tier = Math.log10(number) / 3 | 0;
        if(tier == 0) {
          if (number % 1 !== 0) {
            return round(number)
          }
          return number;
        }
        var suffix = SI_SYMBOL[tier];
        var scale = Math.pow(10, tier * 3);
        var scaled = number / scale;
        return scaled.toFixed(1) + suffix;
      },

      formatDateText(month_year) {
        let month_names = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        let month_names_short = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

        if (month_year && month_year.includes("-")) {
          let res = month_year.split("-");
          return month_names[res[1] - 1] + " " + res[2] + " " + res[0];
        }
        else if (month_year && month_year.includes("/")) {
          let res = month_year.split("/");
          return month_names_short[res[0] - 1] + " " + res[1];
        }
        return month_year
      },

      getReferralInfoLink() {
        return this.referralInfo.info_url;
      },

      onCopy: function (e) {
        // alert('You just copied: ' + e.text);
        this.$bvToast.toast('Referral link copied!', {
          title: 'Successful',
          autoHideDelay: 500,
          variant: 'success',
          solid: true
        });
      },

      onCodeCopy: function (e) {
        this.$bvToast.toast('Referral code copied!', {
          title: 'Successful',
          autoHideDelay: 500,
          variant: 'success',
          solid: true
        });
      },

      onError: function (e) {
        // alert('Failed to copy texts');
      }
    },

    computed: {
      referralInfo() {
        var info = {};
        var user = this.$store.state.general.user;
        info['code'] = user.referral_code;
        info['info_url'] = user.info_url;
        info['url'] = user.referral_url;
        info['count'] = user.num_of_signup || 0;
        info['conversion'] = user.num_of_conversion || 0;
        info['points'] = user.points || 0;
        return info;
      },

      fileDetails() {
        var files = [];
        this.$store.state.files.fileList.forEach(file => {
          files.push(file);
        });
        return files;
      },

      rawFiles() {
        return this.$store.state.files.fileList
      },
      
      files() {
        var files = [];
        this.$store.state.files.fileList.forEach(file => {
          files.push(file.originalName);
        });
        return files;
      },

      incompletenessMessage() {
        if (!this.file) {
          return this.meta.required ? 'Please provide a data file' : '';
        } else {
          return false;
        }
      },
      
      metaList() {
        return this.$store.state.general.metas;
      },

      progress: function() {
        return Math.ceil(100 / this.totalSteps) * this.step;
      },
      
      summaryInsights() {
        this.loading = false;
        return [
          {id: '0', title: "Referrals", description: "Referrals", value: 0, change: 10, period: "1 month"}
        ]
      },
    }
  };
</script>

<style scoped lang="css">

</style>